// extracted by mini-css-extract-plugin
export default {"container":"sq-z","heading":"tq-z","text":"uq-z","info":"vq-z","link":"wq-z","fullMaxWidth":"xq-z"};